import { useMutation } from '@tanstack/react-query';
import { UseMutationOptions } from '@tanstack/react-query';

import { logger } from '@/utils';

import { updateUserCredit } from '../api';
import { creditsQueryKeys } from '../data';

export const useUpdateUserCreditMutation = (
  options: Partial<UseMutationOptions<any, any, any, any>> = {}
) => {
  const mutation = useMutation({
    mutationKey: creditsQueryKeys.updateCredits,

    mutationFn: updateUserCredit,

    onMutate: (data) => {
      return { ...data };
    },
    onSuccess: (data, variables, context) => {
      logger.log(data);
      if (options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },

    onError: (error) => {
      logger.log(error);
    },
    ...options,
  });

  return mutation;
};
